<template>
  <Dialog
    v-model:show="dialogVisible"
    teleport="body"
    class="style-type-dialog"
  >
    <div class="dialog-header">
      <Icon
        class="dialog-header__arrow"
        v-if="showWooView"
        @click="showWooView = false"
        name="arrow-left-l"
      />
      {{ 'Select Style Type' }}
    </div>
    <div
      v-if="!isGDropshipping"
      class="dialog-content"
    >
      <div
        v-if="!showWooView"
        class="select-type"
      >
        <div
          v-for="(item, index) in options"
          :key="index"
          @click="activeIndex = index"
          :class="{ 'active': activeIndex === index }"
          class="type"
        >
          <img
            :src="item"
            alt=""
          >
        </div>
      </div>
      <div
        v-else
        class="woo-view"
      >
        <img
          :src="options[1]"
          height="48px"
          alt=""
        >
        <div class="title">
          Enter your WooCommerce store address below (for example: www.example.com)
        </div>
        <div
          :class="{ 'active': focus }"
          class="input-wrapper"
        >
          <div class="suffix">
            https://
          </div>
          <input
            @focus="focus = true"
            @blur="focus = false"
            v-model="wooUrl"
            placeholder="Please input your WooCommerce store address."
            type="text"
          >
        </div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <div class="buttons">
          <Button
            @click="onCancel"
            class="cancel"
          >
            Cancel
          </Button>
          <Button
            v-if="!showWooView"
            @click="onConfirm"
            class="confirm"
            type="primary"
          >
            Confirm
          </Button>
          <Button
            v-if="showWooView"
            @click="onGoToLink"
            class="confirm"
            :disabled="!wooUrl"
            type="primary"
          >
            Go to Link
          </Button>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { Dialog } from '@/components/Dialog'
import { useDropshipping } from '@/components/Dropshipping/useDropshipping'
import { Icon } from '@/components/Icon'
import { Button } from '@/components/Button'

const {
  dialogVisible,
  options,
  activeIndex,
  showWooView,
  wooUrl,
  focus,
  onCancel,
  onConfirm,
  onGoToLink
} = useDropshipping()

</script>

<style lang='less' scoped>
.style-type-dialog {
  .dialog-header {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #232323;
    font-size: 20px;
    font-family: mon-700;

    &__arrow {
      cursor: pointer;
      font-size: 24px;
    }
  }

  .dialog-content {
    margin-top: 32px;
    margin-bottom: 8px;
    .select-type {
      display: flex;
      gap: 16px;
      .type {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 280px;
        height: 64px;
        border-radius: 8px;
        border: 1px solid #EBF1F5;
        cursor: pointer;
        &.active {
          border: 2px solid #232323;
        }

        > img {
          height: 40px;
        }
      }
    }
    .woo-view {
      .title {
        margin-top: 24px;
        color: #232323;
        font-size: 14px;
        font-family: mon-600;
      }
      .input-wrapper {
        display: flex;
        margin-top: 12px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #EBF1F5;
        &.active {
          border: none;
          outline: 2px solid #232323;
        }
        .suffix {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 96px;
          height: 100%;
          color: #232323;
          font-size: 12px;
          font-family: mon-500;
          background-color: #f8f8f8;
          border-right: none;
        }
        input {
          flex: 1;
          line-height: 48px;
          padding: 0 12px;
          outline: none;
          border: none;
          caret-color: #1153D6;
          &::placeholder {
            color: #b2b7c2;
            font-size: 12px;
            font-family: mon-500;
          }
        }
      }
    }
    .error-tips {
      margin: 24px 0;
      color: #232323;
      font-size: 12px;
      font-family: mon-500;
      line-height: 18px;
      width: 400px;
    }
  }
  .dialog-footer {
    height: 88px;
    border-top: 1px solid #EBF1F5;
    padding: 0 24px;
    .buttons {
      margin-top: 20px;
      display: flex;
      justify-content: end;

      .cancel, .confirm {
        width: 180px;
        height: 44px;
      }

      .confirm {
        margin-left: 16px;
      }
    }
  }
}
</style>
